module.exports = require('./CollectorRepossessorApplicationView');
